module.exports = require('./CollectorRepossessorApplicationView');
